import { Config, Register } from "@cleeng/mediastore-sdk";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PUBLISHER_ID } from "../../../constants";

function RegisterPage() {
  Config.setPublisher(PUBLISHER_ID);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const offerId = params.get("offerId");
  useEffect(() => {
    if (offerId) {
      localStorage.setItem("offerId", offerId);
    }
  }, [offerId]);

  const handleNavigatePayment = () => {
    navigate("/capture")
  }

  const handleNavigateLogin = () => {
    navigate("/")
  }

  return (
    <Register
      onSuccess={handleNavigatePayment}
      onHaveAccountClick={handleNavigateLogin}
    />
  );
}

export default RegisterPage;
